import { ajax, apiUrl, encodePathVariable } from 'cadenza/api-client/api';

/** @see net.disy.cadenza.repository.web.dto.MediaItemMetadataDto */
interface MediaItemMetadataDto {
  mediaItemId: MediaItemIdDto;
  printName: string;
}

/** @see net.disy.cadenza.repository.web.dto.MediaItemIdDto */
interface MediaItemIdDto {
  repositoryName: string;
  contentIdentifier: string;
}

/** @see net.disy.cadenza.repository.web.dto.SignedMediaItemIdDto */
export interface SignedMediaItemIdDto {
  repositoryName: string;
  contentIdentifier: string;
  signature: string;
}

export function saveMediaIntoDatabaseRepository (repositoryName: string, fileName: string, signature: string, printName: string): Promise<SignedMediaItemIdDto> {
  const searchParams = new URLSearchParams({ fileName, signature, printName });
  return ajax(`/repository/${repositoryName}/signedmedia?${searchParams}`, { type: 'POST' });
}

export function getMediaMetadata (repositoryName: string, contentIdentifier: string): Promise<MediaItemMetadataDto> {
  return ajax(`/repository/${repositoryName}/signedmedia/${encodePathVariable(contentIdentifier)}/metadata`, { type: 'GET' });
}

export function getMediaItemDownloadUrl (contentIdentifier: string, repositoryName: string, signature: string) {
  return apiUrl(`/repository/${repositoryName}/signedmedia/`
      + encodePathVariable(contentIdentifier)
      + `?${new URLSearchParams({ signature })}`);
}
